var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18H14.5C15.1857 18 16 17.15 16 16.5V6.5C16 5.85 15.1857 5 14.5 5H12C11.3143 5 11 5.43333 11 6.08333C11 6.73333 11.3143 7.16667 12 7.16667H13.7143L13.7143 15.8333L2.28571 15.8333L2.28571 7.16667H4C4.68571 7.16667 5 6.73333 5 6.08333C5 5.43333 4.68571 5 4 5H1.5C0.814285 5 0 5.85 0 6.5L0 16.5C0 17.15 0.814285 18 1.5 18Z",
    fill: "url(#paint0_linear_271_5019)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90078 4.5L7.00078 3.40001L7.00078 11C7.00078 11.6 7.40078 12 8.00078 12C8.60078 12 9.00078 11.6 9.00078 11L9.00078 3.40001L10.1008 4.5C10.5008 4.9 11.1008 4.9 11.5008 4.5C11.9008 4.10001 11.9008 3.5 11.5008 3.10001L8.70078 0.300005C8.30078 -0.0999937 7.70078 -0.0999937 7.30078 0.300005L4.50078 3.10001C4.10078 3.5 4.10078 4.10001 4.50078 4.5C4.90078 4.9 5.50078 4.9 5.90078 4.5Z",
    fill: "url(#paint1_linear_271_5019)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_271_5019",
    x1: 13.72,
    y1: -0.199999,
    x2: -5.66039,
    y2: 21.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_271_5019",
    x1: 10.7178,
    y1: -4.79999,
    x2: -4.89477,
    y2: 4.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f0a099e3d34a570a2deefe5922efb70e.svg";
export { ForwardRef as ReactComponent };